import React, { useState, useRef } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Avatar } from 'primereact/avatar';
import logo from '../assets/logo1.png';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Menu } from 'primereact/menu';
import { useLocation } from 'react-router-dom';
import './TopMenu.css'
import Login from './Login';
import { removeAuth } from '../slices/authSlice';

const TopMenu = () => {
    const menuRight = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { isLogged, user } = useSelector((state) => state.auth);
    const [visible, setVisible] = useState(false);
    const [selectedPage, setSelectedPage] = useState('');
    const location = useLocation();
    const logout = () => {
        localStorage.removeItem('token');
        dispatch(removeAuth());
        navigate('/')
    };
    const handlePageClick = (page) => {
        setSelectedPage(page);
      };
    const items = [
        {
            label: 'Profile',
            items: [
                {
                    label: user?.email || 'Anonymous',
                    icon: 'pi pi-user'
                },
                {
                    label: 'Logout',
                    icon: 'pi pi-power-off',
                    command: logout
                }
            ]
        }
    ];

    const openLogin = () => {
        setVisible(true)
        setSelectedPage('home');
        navigate('/home');
    }

    const closeLogin = () => {
        setVisible(false)
    }

    const startContent = (
        <React.Fragment>
            <img src={logo} alt="logo" height={50} /><Link className='menuItem cursor-pointer' to="/home"> <h3 className='pl-3'>LP Generator</h3></Link>
        </React.Fragment>
    );
    const privateMenus = (
        <>
            <Link className={`menuItem cursor-pointer ${(selectedPage === 'home' || location.pathname.includes('home')) ? 'highLightTab' : ''}`} to="/home"  onClick={() => handlePageClick('home')}> <h4 >Home</h4> </Link>
            <Link className={`menuItem cursor-pointer ${(selectedPage === 'lplist' || location.pathname.includes('lplist') || location.pathname.includes('view-lp') || location.pathname.includes('edit-lp')) ? 'highLightTab' : ''}`} to="/lplist" onClick={() => handlePageClick('lplist')}> <h4 >Pages</h4></Link>
            <Link className={`menuItem cursor-pointer ${(selectedPage === 'reports' || location.pathname.includes('reports')) ? 'highLightTab' : ''}`} to="/reports" onClick={() => handlePageClick('reports')}> <h4 >Reports</h4></Link>
            <Link className={`menuItem cursor-pointer ${(selectedPage === 'settings' || location.pathname.includes('settings')) ? 'highLightTab' : ''}`} to="/settings" onClick={() => handlePageClick('settings')}> <h4 >Settings</h4></Link>
            <Link className={`menuItem cursor-pointer ${(selectedPage === 's3-explorer' || location.pathname.includes('s3-explorer')) ? 'highLightTab' : ''}`} to="/s3-explorer" onClick={() => handlePageClick('s3-explorer')}> <h4 >S3 Explorer</h4></Link>


        </>
    );

    const centerContent = (
        <div className="flex flex-wrap align-items-center gap-5">
            {isLogged ? privateMenus : null}
        </div>
    );

    const endContent = (
        <React.Fragment>
            {isLogged && <div className="flex align-items-center gap-2">
                <Avatar image={user.profilePhoto ? user.profilePhoto : "https://static.vecteezy.com/system/resources/previews/024/183/502/original/male-avatar-portrait-of-a-young-man-with-a-beard-illustration-of-male-character-in-modern-color-style-vector.jpg"} shape="circle" />
                <span className="font-bold text-bluegray-50 cursor-pointer" onClick={(event) => menuRight.current.toggle(event)} >{user.name}</span>
                <Menu model={items} popup ref={menuRight} id="popup_menu_right" popupAlignment="right" />

            </div>

            }
            {!isLogged && <div className="flex align-items-center gap-2">
                <span className="font-bold text-bluegray-50 cursor-pointer" onClick={openLogin}>Login</span>
            </div>}
        </React.Fragment>
    );

    return (
        <div className="card">
            <Toolbar start={startContent} center={centerContent} end={endContent} className="bg-primary shadow-2 " />
            <Login open={visible} closeLogin={closeLogin}></Login>
        </div>
    );
}

export default TopMenu
